<template>
  <div class="star_enterprise">
    <page-box :title="'明星产品'">
      <div class="content">
        <div class="overview">
          <div class="item" v-for="(item, index) in data" :key="index">
            <img :src="item.icon" alt="" class="icon" />
          </div>
        </div>

        <div class="echarts_content">
          <my-echarts :options="overViewEcharts"></my-echarts>
        </div>
      </div>
    </page-box>
  </div>
</template>

<script setup>
import PageBox from '@/components/pageBox/PageBox';
import { ref, reactive, onMounted } from 'vue';
import MyEcharts from '@/baseCpm/MyEcharts/MyEcharts.vue';
import * as echarts from 'echarts';

const data = reactive([
  {
    id: 0,
    icon: require('@/assets/images/Industry/jianlibao.png'),
  },
  {
    id: 1,
    icon: require('@/assets/images/Industry/baoshi.png'),
  },
  {
    id: 2,
    icon: require('@/assets/images/Industry/huizhi.png'),
  },
  {
    id: 3,
    icon: require('@/assets/images/Industry/brige.png'),
  },
]);

let overViewData = ref({
  all: 100,
  color: [
    // rgba(249, 205, 92, 1)
    'rgba(249, 205, 92, 1)',
    // rgba(223, 52, 187, 1)
    'rgba(223, 52, 187, 1)',
    //  rgba(19, 139, 247, 1)
    'rgba(19, 139, 247, 1)',
    // rgba(142, 54, 217, 1)
    'rgba(142, 54, 217, 1)',
    // rgba(253, 126, 73, 1)
    'rgba(253, 126, 73,1)',
  ],
  arr: [
    {
      name: '金汤酸菜鱼',
      value: 600,
    },
    {
      name: '快煮黑鱼片',
      value: 280,
    },
    {
      name: '藤椒酸菜鱼',
      value: 720,
    },
    {
      name: '现切黑鱼片',
      value: 400,
    },
    {
      name: '其他',
      value: 450,
    },
  ],
});
const color1 = [
  {
    c1: 'rgba(249, 205, 92, 1)',
    c2: 'rgba(249, 205, 92, 0.3)',
  },
  {
    c1: 'rgba(223, 52, 187, 1)',
    c2: 'rgba(223, 52, 187, 0.3)',
  },

  {
    c1: 'rgba(19, 139, 247, 1)',
    c2: 'rgba(19, 139, 247, 0.3)',
  },

  {
    c1: ' rgba(142, 54, 217, 1)',
    c2: ' rgba(142, 54, 217, 0.3)',
  },

  {
    c1: 'rgba(253, 126, 73,1)',
    c2: 'rgba(253, 126, 73,0.3)',
  },
];

let overViewEcharts = ref(null);
const getEcharts = () => {
  let all = 0;
  overViewData.value.arr.forEach((item) => {
    all += item.value;
  });
  overViewData.value.all = all;
  overViewEcharts.value = {
    color: overViewData.value.color,
    series: [
      {
        name: 'Access From',
        type: 'pie',
        radius: ['30%', '50%'],
        center: ['50%', '50%'],
        avoidLabelOverlap: false,
        labelLine: {
          show: true,
        },
        label: {
          show: true,
          fontSize: 11.81,
          color: '#E4EFFF',
          formatter(param) {
            // correct the percentage
            return param.name;
          },
        },
        itemStyle: {
          normal: {
            color: function (params) {
              var colorList = color1;
              return new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                {
                  //颜色渐变函数 前四个参数分别表示四个位置依次为左、下、右、上

                  offset: 0,
                  color: colorList[params.dataIndex].c1,
                },
                {
                  offset: 1,
                  color: colorList[params.dataIndex].c2,
                },
              ]);
              /*  return colorList[params.dataIndex]*/
            },
          },
        },
        data: overViewData.value.arr,
      },
    ],
  };
};

onMounted(() => {
  getEcharts();
});
</script>

<style lang="scss" scoped>
.star_enterprise {
  margin-bottom: 5px;
  .content {
    margin-left: 20px;
    // margin-top: 21px;
    width: 310px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .overview {
      width: 310px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 13px;
      margin-left: 10px;
      .item {
        width: 62.44px;
        height: 42.19px;
        > .icon {
          width: 62.44px;
          height: 42.19px;
        }
      }
    }
    .echarts_content {
      width: 310px;
      height: 180.83px;
    }
  }
}
</style>
